import { Box, Grid, Paper, Typography } from "@material-ui/core";
import Controls from "../../../../components/controls/Controls";
import FormBase from "../../../../forms/FormBase";
import AttachmentForm from "../../../../forms/multiprofissional/AttachmentForm";
import FormFieldAttachmentBase, { FieldAttachment } from "../../../../forms/FormFieldAttachmentBase";



interface IMultiprofissionalAttachmentDataComponentProps {
    MultiprofissionalAttachmentForm: AttachmentForm,
    onInputChange: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void
    onDeleteFile: (name: string, form: FormBase, fieldAttachment: FieldAttachment, formField: FormFieldAttachmentBase) => void
}

export default function CorpoClinicoAttachmentDataComponent(props: IMultiprofissionalAttachmentDataComponentProps) {

    return (
        <div>
            <Grid container spacing={10}>

                <Grid item xs={6}>

                    <Grid container spacing={5}>
                        <Grid item xs={12}>
                            <Controls.Attachment label='Atestado de Capacidade Física e Cognitiva *' name="AtestadoCapacidadeFisicaCognitiva"
                                limitedFiles={props.MultiprofissionalAttachmentForm.AtestadoCapacidadeFisicaCognitiva.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.AtestadoCapacidadeFisicaCognitiva.Values}
                                error={props.MultiprofissionalAttachmentForm.AtestadoCapacidadeFisicaCognitiva.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("AtestadoCapacidadeFisicaCognitiva", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.AtestadoCapacidadeFisicaCognitiva);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("AtestadoCapacidadeFisicaCognitiva", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.AtestadoCapacidadeFisicaCognitiva);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Carta de apresentação da empresa ou do Médico Titular da Equipe com justificativa da solicitação e se co-responsabilizando pelo profissional a ser cadastrado *' name="CartaReferencia"
                                limitedFiles={props.MultiprofissionalAttachmentForm.CartaReferencia.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.CartaReferencia.Values}
                                error={props.MultiprofissionalAttachmentForm.CartaReferencia.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CartaReferencia", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CartaReferencia);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CartaReferencia", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CartaReferencia);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Carteira de Vacinação ou termo de recusa' name="CarteiraVacionacaoTermoRecusa"
                                limitedFiles={props.MultiprofissionalAttachmentForm.CarteiraVacionacaoTermoRecusa.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.CarteiraVacionacaoTermoRecusa.Values}
                                error={props.MultiprofissionalAttachmentForm.CarteiraVacionacaoTermoRecusa.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CarteiraVacionacaoTermoRecusa", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CarteiraVacionacaoTermoRecusa);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CarteiraVacionacaoTermoRecusa", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CarteiraVacionacaoTermoRecusa);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Comprovante do Pagamento da Anuidade do Conselho Profissional *' name="ComprovantePagamentoAnuidadeConselhoProfissional"
                                limitedFiles={props.MultiprofissionalAttachmentForm.ComprovantePagamentoAnuidadeConselhoProfissional.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.ComprovantePagamentoAnuidadeConselhoProfissional.Values}
                                error={props.MultiprofissionalAttachmentForm.ComprovantePagamentoAnuidadeConselhoProfissional.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("ComprovantePagamentoAnuidadeConselhoProfissional", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.ComprovantePagamentoAnuidadeConselhoProfissional);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("ComprovantePagamentoAnuidadeConselhoProfissional", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.ComprovantePagamentoAnuidadeConselhoProfissional);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Cópia da Carteira do Conselho Profissional *' name="CopiaCarteiraConselho"
                                limitedFiles={props.MultiprofissionalAttachmentForm.CopiaCarteiraConselho.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.CopiaCarteiraConselho.Values}
                                error={props.MultiprofissionalAttachmentForm.CopiaCarteiraConselho.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CopiaCarteiraConselho", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaCarteiraConselho);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CopiaCarteiraConselho", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaCarteiraConselho);
                                }} />
                        </Grid>

                       

                    </Grid>
                </Grid>

                <Grid item xs={6}>
                    <Grid container spacing={5}>


                        <Grid item xs={12}>
                            <Controls.Attachment label='Cópia do Diploma de Graduação Profissional *' name="CopiaDiplomaGraduacaoProfissional"
                                limitedFiles={props.MultiprofissionalAttachmentForm.CopiaDiplomaGraduacaoProfissional.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.CopiaDiplomaGraduacaoProfissional.Values}
                                error={props.MultiprofissionalAttachmentForm.CopiaDiplomaGraduacaoProfissional.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CopiaDiplomaGraduacaoProfissional", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaDiplomaGraduacaoProfissional);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CopiaDiplomaGraduacaoProfissional", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaDiplomaGraduacaoProfissional);
                                }} />
                        </Grid>


                        <Grid item xs={12}>
                            <Controls.Attachment label='Cópia do RG e CPF *' name="CopiaRGCPF"
                                limitedFiles={props.MultiprofissionalAttachmentForm.CopiaRGCPF.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.CopiaRGCPF.Values}
                                error={props.MultiprofissionalAttachmentForm.CopiaRGCPF.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CopiaRGCPF", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaRGCPF);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CopiaRGCPF", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaRGCPF);
                                }} />
                        </Grid>


                        <Grid item xs={12}>
                            <Controls.Attachment label='Currículo Resumido Atualizado *' name="CurriculoResumidoAtualizado"
                                limitedFiles={props.MultiprofissionalAttachmentForm.CurriculoResumidoAtualizado.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.CurriculoResumidoAtualizado.Values}
                                error={props.MultiprofissionalAttachmentForm.CurriculoResumidoAtualizado.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("CurriculoResumidoAtualizado", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CurriculoResumidoAtualizado);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("CurriculoResumidoAtualizado", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CurriculoResumidoAtualizado);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Declaração de Conflito  *' name="DeclaracaoConflito"
                                limitedFiles={props.MultiprofissionalAttachmentForm.DeclaracaoConflito.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.DeclaracaoConflito.Values}
                                error={props.MultiprofissionalAttachmentForm.DeclaracaoConflito.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("DeclaracaoConflito", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.DeclaracaoConflito);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("DeclaracaoConflito", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.DeclaracaoConflito);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Uma foto 3x4 fundo branco *' name="FotoFundoBranco"
                                limitedFiles={props.MultiprofissionalAttachmentForm.FotoFundoBranco.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.FotoFundoBranco.Values}
                                error={props.MultiprofissionalAttachmentForm.FotoFundoBranco.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("FotoFundoBranco", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.FotoFundoBranco);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("FotoFundoBranco", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.FotoFundoBranco);
                                }} />
                        </Grid>

                        <Grid item xs={12}>
                            <Controls.Attachment label='Comprovante de Vacinação COVID19' name="ComprovanteVacinaCovid"
                                limitedFiles={props.MultiprofissionalAttachmentForm.ComprovanteVacinaCovid.LimitedFiles} typeFiles={'image/*, .pdf'}
                                values={props.MultiprofissionalAttachmentForm.ComprovanteVacinaCovid.Values}
                                error={props.MultiprofissionalAttachmentForm.ComprovanteVacinaCovid.Error}
                                onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                    props.onDeleteFile("ComprovanteVacinaCovid", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.ComprovanteVacinaCovid);
                                }}
                                onChange={(fieldAttachment: FieldAttachment) => {
                                    props.onInputChange("ComprovanteVacinaCovid", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.ComprovanteVacinaCovid);
                                }} />
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>

            <br />
            <br />

            <Paper variant="outlined" >
                <Box p={1}>

                    <Typography variant="subtitle1" gutterBottom component="div">
                        Cópia do Título de Especialista ou Residência Médica *
                    </Typography>

                    <Grid container spacing={10}>

                        <Grid item xs={6}>

                            <Grid container spacing={5}>
                                <Grid item xs={12}>
                                    <Controls.Attachment label='Título de Especialista' name="CopiaTituloEspecialista"
                                        limitedFiles={props.MultiprofissionalAttachmentForm.CopiaTituloEspecialista.LimitedFiles} typeFiles={'image/*, .pdf'}
                                        values={props.MultiprofissionalAttachmentForm.CopiaTituloEspecialista.Values}
                                        error={props.MultiprofissionalAttachmentForm.CopiaTituloEspecialista.Error}
                                        onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                            props.onDeleteFile("CopiaTituloEspecialista", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaTituloEspecialista);
                                        }}
                                        onChange={(fieldAttachment: FieldAttachment) => {
                                            props.onInputChange("CopiaTituloEspecialista", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaTituloEspecialista);
                                        }} />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={6}>
                            <Grid container spacing={5}>
                                <Grid item xs={12}>
                                    <Controls.Attachment label='Residência Médica' name="CopiaResidenciaMedica"
                                        limitedFiles={props.MultiprofissionalAttachmentForm.CopiaResidenciaMedica.LimitedFiles} typeFiles={'image/*, .pdf'}
                                        values={props.MultiprofissionalAttachmentForm.CopiaResidenciaMedica.Values}
                                        error={props.MultiprofissionalAttachmentForm.CopiaResidenciaMedica.Error}
                                        onDeleteFile={(fieldAttachment: FieldAttachment) => {
                                            props.onDeleteFile("CopiaResidenciaMedica", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaResidenciaMedica);
                                        }}
                                        onChange={(fieldAttachment: FieldAttachment) => {
                                            props.onInputChange("CopiaResidenciaMedica", props.MultiprofissionalAttachmentForm, fieldAttachment, props.MultiprofissionalAttachmentForm.CopiaResidenciaMedica);
                                        }} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                    <br />
                    <Typography variant="caption" display="block" gutterBottom>
                        Obs.: Pode ser anexado um arquivo.
                    </Typography>
                </Box>
            </Paper>

            <br />
            <br />

        </div >
    );
}